import { SplixerResourceInterface } from './splixer-resource.interface';
import { FieldConfig, FieldDataTypes, NameableInterface, nNumber, nString } from '@hidat/huijs-common';
import { ResourceConfig, SearchFilterConfig } from '@hidat/huijs-resource';
import { splixerFieldConfigs, splixerSystemFields } from './splixer-fields.const';
import { SortOrder } from '@hidat/huijs-api';
import { BrandedResource, ExtendedBrandingInterface } from './branded-resource.interface';
import { HashViews } from './hash-views';
import { SplixerResourceTypes } from './splixer-resource-types';

export const ShowConfig: ResourceConfig = new ResourceConfig(SplixerResourceTypes.Show)
  .addFields(
    [
      splixerFieldConfigs.uid,
      splixerFieldConfigs.name,
      splixerFieldConfigs.tagLine,
      splixerFieldConfigs.description,
      splixerFieldConfigs.imageUrl,
      splixerFieldConfigs.branding,
      new FieldConfig('hostName'),
      new FieldConfig('startedAt', FieldDataTypes.DATETIME),
      new FieldConfig('endedAt', FieldDataTypes.DATETIME),
      new FieldConfig('duration', FieldDataTypes.INTEGER),
      new FieldConfig('priority', FieldDataTypes.INTEGER),
    ],
    true,
    HashViews.player,
  )
  .addFields([
    splixerFieldConfigs.intId,
    splixerFieldConfigs.channelId,
    splixerFieldConfigs.hostId,
    splixerFieldConfigs.programId,
    splixerFieldConfigs.stationId,
    splixerFieldConfigs.remoteId,
    splixerFieldConfigs.status,
    ...splixerSystemFields,
    new FieldConfig('dow', FieldDataTypes.INTEGER),
    new FieldConfig('timeOfDay', FieldDataTypes.INTEGER),
    new FieldConfig('validSegments').setEditable(false),
    new FieldConfig('invalidSegments').setEditable(false),
    new FieldConfig('rawShowId', FieldDataTypes.INTEGER),
  ])
  .setSorts({
    name: {
      dbName: 'name',
      secondarySort: {
        dbName: 'started_at',
        order: SortOrder.DESC,
      },
    },
    startedat: {
      dbName: 'started_at',
      defaultOrder: SortOrder.DESC,
    },
  })
  .setDefaultSort('startedat');

export const ShowIncludes = {
  host: 'host',
  program: 'program',
  station: 'station',
  channel: 'channel',
};

export const ShowFilterConfig = new SearchFilterConfig(ShowConfig, {
  only: ['hostId', 'programId', 'channelId','priority', 'status']
})
  .addRangeField('startedAt', FieldDataTypes.DATE);

export interface ShowBrandingInterface extends ExtendedBrandingInterface {
  credits?: nString;
  // Depreciate????
  urls?: {
    video_link?: nString;
    blog_link?: nString;
  };
  tags?: {
    keywords?: string;
  };
  performers?: nString;
  coHostId?: nNumber;
  coHostName?: nString;
}

export interface PlayerShowInterface
  extends
    SplixerResourceInterface<number>,
    NameableInterface,
    BrandedResource<number> {
  tagLine: string | undefined;
  description: string | undefined;
  imageUrl: string | undefined;
  branding: ShowBrandingInterface | undefined;

  startedAt: unknown | undefined;
  endedAt: unknown | undefined;
  duration: number | undefined;
  hostName: string | undefined;
  dow: number | undefined;
  timeOfDay: number | undefined;
  priority: number | undefined;
}

export interface ShowInterface extends PlayerShowInterface {
  validSegments: number | undefined;
  invalidSegments: number | undefined;

  hostId: number | undefined;
  channelId: number | undefined;
  programId: number | undefined;
  stationId: number | undefined;
  remoteId: number | undefined;
  rawShowId: number | undefined;
}
